import React from 'react';
interface CtaSectionProps {
  onOpenWaitlist: () => void;
}
export const CtaSection: React.FC<CtaSectionProps> = ({
  onOpenWaitlist
}) => {
  return <section aria-labelledby="cta-heading" className="section-y bg-deep-juniper" data-id="element-45" data-mp="c5etlz9ak4qo">
      <div className="section-container" data-id="element-46" data-mp="h0u7gr7au0n3">
        <div className="mx-auto max-w-2xl text-center" data-id="element-47" data-mp="m1i3jradx7o6">
          <h2 id="cta-heading" className="section-heading text-white" data-id="element-48" data-mp="m330too334pq">
            Stay connected as Re:Joy takes shape.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/85" data-id="element-49" data-mp="v26katr5xm4r">
            Join the waitlist for updates on the care experience we’re building.
          </p>
          <button type="button" onClick={onOpenWaitlist} className="btn-primary mt-8 focus-visible:ring-white focus-visible:ring-offset-deep-juniper" data-id="element-50" data-mp="ztg6tlhf09cf">
            Join the waitlist
          </button>
        </div>
      </div>
    </section>;
};